<app-account-item
  [accountTitle]="accountTitle()"
  [accountStatus]="account().accountStatus"
  [showAutoPay]="false"
  (onTitleClick)="emitCreditCardClick()"
>
  <div class="amount-details-row">
    <div class="amount-details-row__left">
      <img
        src="../../../../../assets/images/Small card.png"
        alt="small card image"
        class="amount-details-row__left--img"
        (click)="emitCreditCardClick()"
      />
      <app-amount-display
        heading="current balance"
        [dollarAmount]="account().balance"
        [testId]="'customer-hub-card-balance'"
        class="card-account-balance"
      ></app-amount-display>
    </div>
    <div class="amount-details-row__right">
      <button class="make-payment" data-test-id="customer-hub-card-make-payment-button" (click)="emitCreditCardClick()">
        Make a payment
      </button>
    </div>
  </div>
</app-account-item>
